/* eslint-disable linebreak-style */
// 不同环境服务器配置
const addressConfig = {
  // 开发环境
  development: {
    CDN_ADDRESS: '/',
    // 数据接口API服务器
    API_ADDRESS: 'http://10.190.65.49:9010',
    CALENDAR_SYNC_API_ADDRESS: 'http://10.190.46.123',
    // 单点接入appkey
    APP_KEY: '6eed8a28-5841-4001-9187-5dc57ed4d5af',
    // 吉利单点认证服务器
    OOS_ADDRESS: 'http://passport-test.test.geely.com',
  },
  // 测试环境
  test: {
    CDN_ADDRESS: '/',
    API_ADDRESS: 'http://10.190.65.49:9010',
    CALENDAR_SYNC_API_ADDRESS: 'http://10.190.46.123',
    APP_KEY: '6eed8a28-5841-4001-9187-5dc57ed4d5af',
    OOS_ADDRESS: 'http://passport-test.test.geely.com',
  },
  // 预发环境
  pre: {
    CDN_ADDRESS: '/',
    API_ADDRESS: 'http://10.190.65.49:9010',
    CALENDAR_SYNC_API_ADDRESS: 'http://10.200.159.76:8009',
    APP_KEY: '6eed8a28-5841-4001-9187-5dc57ed4d5af',
    OOS_ADDRESS: 'http://passport-pre.test.geely.com',
  },
  // 正式环境
  production: {
    CDN_ADDRESS: '/',
    API_ADDRESS: 'https://mailservice.geely.com/exchangeapi',
    CALENDAR_SYNC_API_ADDRESS: 'http://10.200.159.76:8009',
    APP_KEY: '15903999-d59f-4c7c-b28c-1007aba34694',
    OOS_ADDRESS: 'https://passport.geely.com',
  },
};

// 在.env.[mode]文件中设置VUE_APP_ENV变量，根据不同环境读取不同配置
// 不使用process.env.NODE_ENV是因为webpack只根据NODE_ENV = 'production'来区分开发环境
// 测试和预发也需要按开发环境打包，所以另外用VUE_APP_ENV来做判断，引入不同环境服务器配置
const config = addressConfig[process.env.VUE_APP_ENV || 'development'];

module.exports = config;
